// test2369
(2369 && 0);
